import { HOW_CAPTURE_LIVE, HOW_CAPTURE_ROWS } from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";
import HowItWorksMockExchange from "./HowItWorksMockExchange";

export default function HowItWorksMockCapture() {
  return (
    <div className={styles.card}>
      <HowItWorksMockExchange row={HOW_CAPTURE_LIVE} isLive />

      <div className={styles.rows}>
        {HOW_CAPTURE_ROWS.map((row) => (
          <HowItWorksMockExchange key={row.company} row={row} />
        ))}
      </div>
    </div>
  );
}
